import React from "react";
import { Redirect } from "react-router-dom";

import PageContent from "components/PageContent";
import ErrorBanner from "components/ErrorBanner";
import { useUserExists } from "hooks/useUserExists";

interface Props {
	isWaitingForData?: boolean;
	isError?: boolean;
	requireUserExists?: { uid?: string; vanityUrl?: string };
}

const PageWithData: React.FunctionComponent<Props> = ({
	isWaitingForData = false,
	isError,
	requireUserExists = { uid: undefined, vanityUrl: undefined },
	children
}) => {
	const { output: userExistenceData } = useUserExists(requireUserExists);
	if (
		(requireUserExists.uid !== undefined ||
			requireUserExists.vanityUrl !== undefined) &&
		userExistenceData &&
		userExistenceData.userExists === false
	) {
		return <Redirect to="/" />;
	}

	if (isWaitingForData) {
		return <PageContent></PageContent>;
	}

	if (isError) {
		return (
			<PageContent>
				<ErrorBanner />
			</PageContent>
		);
	}

	return <PageContent>{children}</PageContent>;
};

export default PageWithData;
